export default __webpack_public_path__ + "static/topic6-614e40e35955a9f3508cdb15c3908c76.png";